import styled from 'styled-components';

export const StyledConceptWriteAnswer = styled.div`
  display: flex;
  position: absolute;
  top: 45%;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 10px;
  button {
    border-radius: 4px;
    line-height: 1;
  }
  .answer-input {
    display: flex;
    flex-direction: row;
    width: 45%;
    height: 2em;
    align-items: center;
    gap: 10px;
    .ant-input-affix-wrapper {
      border-radius: 4px;

      input {
        border-radius: 0;
      }
    }
    .ok-button {
      height: 100%;
      background: white;
    }
  }
  .spanish-characters {
    display: flex;
    gap: 10px;
    flex-direction: row;
    width: 45%;
    justify-content: space-between;
    align-items: center;
  }
`;
